module.exports = __webpack_public_path__ + "static/media/bianco.556008f5.eot";